import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import queryString from 'query-string';
// import Drawer from '@material-ui/core/Drawer';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import ReadMoreReact from 'read-more-react';
import ReplyIcon from '@material-ui/icons/Reply';
import Modal from '@material-ui/core/Modal';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import InfiniteScroll from 'react-infinite-scroller';
import Header from '../../components/Header';
// import MenuDrawer from '../../components/MenuDrawer';
import SearchButton from '../../components/atoms/SearchButton';
import CsvDownloadButton from '../../components/atoms/CsvDownloadButton';
import CsvDownloadShopButton from '../../components/atoms/CsvDownloadShopButton';
import ViewClassicModeButton from '../../components/atoms/ViewClassicModeButton';
import ViewResponsiveModeButton from '../../components/atoms/ViewResponsiveModeButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import GochiHistoryTable from '../organisms/GochiHistoryTable';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import DownloadCsvDialogConfirm from '../../components/molecules/DownloadCsvDialogConfirm';
import {
  getGochis,
  getGochisShop,
  downloadGochiShop,
  downloadGochi,
  postShopReply,
  postShashokuShopReply,
  updateAmountEducationSystem,
  getUpdateAmountHistoryDetail,
  getRemainAmountUpdateAmount,
  UPDATE_AMOUNT_EDUCATION_SYSTEM_SUCCESS,
  GET_UPDATE_AMOUNT_HISTORY_DETAIL_SUCCESS,
  GET_REMAIN_AMOUNT_UPDATE_AMOUNT_SUCCESS
} from '../../actions/Gochis';
import MenuBox from '../../components/MenuBox';
import NotifyPopupShop from '../../components/molecules/NotifyPopupShop';
import { getAccounts } from '../../actions/Accounts';
import depositPlans from '../../constants/DepositPlan';
import enabledStripeBilling from '../../constants/StripeBilling';
import { getTextBySystem as gts } from '../../utils';
import UpdateAmountHistoryModal from '../organisms/UpdateAmountHistoryModal';
import UpdateAmountModal from '../organisms/UpdateAmountModal';
import UpdateAmountConfirmModal from '../organisms/UpdateAmountConfirmModal';
import UpdateAmountSuccessModal from '../organisms/UpdateAmountSuccessModal';

const Accordion = withStyles({
  root: {
    border: 0,
    boxShadow: 'none',
    '&::before': {
      display: 'none'
    },
    '&$expanded': {
      margin: 'auto'
    }
  },
  expanded: {}
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    '&$expanded': {
      minHeight: 48
    }
  },
  content: {
    '&$expanded': {
      margin: '12px 0'
    }
  },
  expanded: {}
})(MuiAccordionSummary);

const AccordionDetails = withStyles({
  root: {
    padding: 0,
    display: 'block'
  }
})(MuiAccordionDetails);

const styles = theme => ({
  root: {
    backgroundColor: '#F7F7F7',
    flexGrow: 1,
    width: '100%',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 375,
      backgroundColor: '#F7F7F7',
      margin: '0 auto'
    }
  },
  rootClassic: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  mainContent: {
    padding: 15
  },
  pageTitileDiv: {
    textAlign: 'left',
    marginBottom: 10
  },
  mainPaper: {
    position: 'relative'
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 20px 20px 20px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '100%',
    marginTop: 0
  },
  textField150: {
    padding: '0px 5px 0px 5px',
    width: '250px'
  },
  textField300: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  button: {
    margin: '5px 5px'
  },
  buttonLeft: {
    textAlign: 'left',
    float: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  },
  fs24: {
    fontSize: '24px'
  },
  fs20: {
    fontSize: '20px'
  },
  buttonCenter: {
    padding: '10px',
    textAlign: 'center'
  },
  gochiBox: {
    padding: 12,
    borderTop: '1px solid #DBDBDB'
  },
  gochiHeader: {
    padding: '10px',
    color: '#ffffff',
    fontSize: 12,
    textAlign: 'center',
    backgroundColor: '#717171',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    position: 'relative',
    marginBottom: 20,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',

    '&:before': {
      content: '""',
      position: 'absolute',
      left: '50%',
      bottom: '-12px',
      transform: 'translateY(-50%)',
      display: 'inline-block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '8px 5px 0 5px',
      borderColor: '#717171 transparent transparent transparent'
    }
  },
  couponNo: {
    margin: '0 20px',
    fontSize: 19,
    fontWeight: 'bold',
    lineHeight: '22px',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  textCompare: {
    display: 'inline-block',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  remainCoupon: {
    backgroundColor: '#FFD0D5',
    color: '#000000',

    '&:before': {
      borderColor: '#FFD0D5 transparent transparent transparent'
    }
  },
  gochiCoupon: {
    backgroundColor: '#fffbd0',
    color: '#000000',

    '&:before': {
      borderColor: '#fffbd0 transparent transparent transparent'
    }
  },
  tableInfo: {
    width: '100%'
  },
  tableInfoCellHeader: {
    padding: '2px 10px',
    width: '90px',
    borderBottom: '2px solid #ffffff',
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#000000',
    backgroundColor: '#F7F7F7'
  },
  tableInfoCell: {
    padding: '2px 10px',
    borderBottom: '2px solid transparent',
    fontSize: '12px',
    whiteSpace: 'break-spaces',
    wordBreak: 'break-all'
  },

  boxMessage: {
    padding: '8px 10px',
    border: '1px solid #DBDBDB',
    borderRadius: 6,
    fontSize: 12,
    color: '#000000',
    marginTop: 15
  },
  messageTtl: {
    marginBottom: 5,
    display: 'flex',
    width: '100%',
    alignItems: 'center'
  },
  iconReply: {
    fontSize: 18,
    display: 'inline-block',
    marginRight: 5
  },
  boxMessageReply: {
    fontSize: 12,
    paddingLeft: 10,
    marginTop: 10,
    whiteSpace: 'pre-line'
  },
  inputRoot: {
    width: '100%'
  },
  inputMessage: {
    borderColor: '#DBDBDB',
    borderRadius: 0,
    padding: '10px 15px',
    height: 70,
    fontSize: 12
  },
  buttonSend: {
    marginLeft: 'auto',
    height: 22,
    fontSize: 12,
    padding: 0
  },
  messageReplyBox: {
    backgroundColor: '#F7F7F7',
    borderRadius: 6,
    padding: '8px 10px',
    whiteSpace: 'pre-line'
  },
  textRedBig: {
    color: '#F50357'
  },
  textRed: {
    color: '#F1226D'
  },
  textId: {
    fontSize: 10,
    color: '#777777',
    display: 'inline-block',
    marginLeft: 5
  },
  textCenter: {
    textAlign: 'center',
    marginTop: 15
  },
  searchCollapseBox: {
    marginBottom: '20px'
  },
  collapseBtn: {
    minHeight: 'unset !impotant',
    margin: '0',
    padding: 0
  },

  extendClasses: {
    margin: 0
  },

  gochiChargeHeader: {
    backgroundColor: '#d0dbff',
    '&:before': {
      borderColor: '#d0dbff transparent transparent transparent'
    }
  },
  button220: {
    width: 220
  },
  textNoteCsv: {
    fontSize: 12,
    width: 220,
    margin: '0 auto',
    textAlign: 'left'
  },
  textNoteClassicCsv: {
    fontSize: 12,
    width: 220,
    marginLeft: 'auto',
    textAlign: 'left'
  },
  textLinkCsv: {
    color: '#2196F3'
  },
  btnUpdateAmountHistory: {
    fontSize: 12,
    fontWeight: 400,
    color: '#2196F3',
    margin: '5px 0 0',
    cursor: 'pointer',
    padding: 0,
    textAlign: 'left',
    justifyContent: 'unset'
  },
  btnUpdateAmount: {
    fontSize: 12,
    fontWeight: 400,
    color: '#F50057',
    margin: '5px 0 0',
    cursor: 'pointer',
    padding: 0,
    textAlign: 'left',
    justifyContent: 'unset'
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      gochiTypes: state.gochis.gochiTypesShop,
      gochiUserTypes: state.gochis.gochiUserTypesShop,
      gochiStatuses: state.gochis.gochiStatuses
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochis,
          getGochisShop,
          downloadGochiShop,
          downloadGochi,
          postShopReply,
          getAccounts,
          postShashokuShopReply,
          updateAmountEducationSystem,
          getUpdateAmountHistoryDetail,
          getRemainAmountUpdateAmount
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openModal', 'updateOpenModal', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('menuId', 'setMenuId', ''),
  withState('menuName', 'setMenuName', ''),
  withState('userName', 'setUserName', ''),
  withState('gochiType', 'setGochiType', ''),
  withState('gochiUserType', 'setGochiUserType', ''),
  withState('isShashoku', 'setIsShashoku', ''),
  withState('gochiDateFrom', 'setGochiDateFrom', () => {
    moment.tz.setDefault('Asia/Tokyo');
    return moment()
      .date(1)
      .format('YYYY-MM-DD');
  }),
  withState('gochiDateTo', 'setGochiDateTo', () => {
    return moment()
      .endOf('month')
      .format('YYYY-MM-DD');
  }),
  withState('gochiStatus', 'setGochiStatus', ''),
  withState('gochiUseDateFrom', 'setGochiUseDateFrom', ''),
  withState('gochiUseDateTo', 'setGochiUseDateTo', ''),
  withState('gochiUseDateEnableFlg', 'setGochiUseDateEnableFlg', true),
  withState('gochiBillNo', 'setGochiBillNo', ''),
  withState('listGochi', 'setListGochi', []),
  withState('hasMore', 'setHasMore', false),
  withState('nextHref', 'setNextHref', 1),
  withState('messageReply', 'setMessageReply', []),
  withState('shopReplyText', 'setShopReplyText', ''),
  withState('shashokuShopReplyText', 'setShashokuShopReplyText', ''),
  withState('shashokuMessageReply', 'setShashokuMessageReply', []),
  withState('childKey', 'setChildKey', 0),
  withState('openNotifyPopup', 'setOpenNotifyPopup', false),
  withState('depositPlan', 'setDepositPlan', ''),
  withState('textTitle', 'setTextTitle', ''),
  withState('textMessage', 'setTextMessage', ''),
  withState('expandedCollapse', 'setExpandedCollapse', false),
  withState('gochisAll', 'setGochisAll', []),
  withState('perPage', 'setPerPage', 10),
  withState('viewClassicMode', 'setViewClassicMode', false),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('openPopupCsv', 'setOpenPopupCsv', false),
  withState('isZip', 'setIsZip', false),
  withState('isGochiKid', 'setIsGochiKid', ''),
  withState(
    'showUpdateAmountHistoryModal',
    'setShowUpdateAmountHistoryModal',
    false
  ),
  withState('showUpdateAmountModal', 'setShowUpdateAmountModal', false),
  withState(
    'showUpdateAmountConfirmModal',
    'setShowUpdateAmountConfirmModal',
    false
  ),
  withState(
    'showUpdateAmountSuccessModal',
    'setShowUpdateAmountSuccessModal',
    false
  ),
  withState('gochiChoseUpdateAmount', 'setGochiChoseUpdateAmount', null),
  withState(
    'couponGochiChoseUpdateAmount',
    'setCouponGochiChoseUpdateAmount',
    null
  ),
  withState(
    'systemNameGochiChoseUpdateAmount',
    'setSystemNameGochiChoseUpdateAmount',
    ''
  ),
  withState('oldAmountUpdateAmount', 'setOldAmountUpdateAmount', null),
  withState('maxAmountCanUpdate', 'setMaxAmountCanUpdate', 0),
  withState('amountUpdated', 'setAmountUpdated', null),
  withState('amountUpdatedError', 'setAmountUpdatedError', ''),
  withState('crfsToken', 'setCrfsToken', ''),
  withState('updateAmountHistoryDetail', 'setUpdateAmountHistoryDetail', null),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangePage: props => (event, page, limit, viewClassicMode) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      if (props.viewClassicMode || viewClassicMode) {
        const rowsPerPage = document.getElementById('rowsPerPage');
        let limitNum = 100;
        if (rowsPerPage) {
          limitNum = rowsPerPage.textContent;
        }
        const searchKey = {
          groupName: props.groupName,
          shopName: props.shopName,
          address: props.address,
          menuName: props.menuName,
          userName: props.userName,
          gochiType: props.gochiType,
          gochiUserType: props.gochiUserType,
          gochiDateFrom: props.gochiDateFrom,
          gochiDateTo: props.gochiDateTo,
          gochiStatus: props.gochiStatus,
          gochiUseDateFrom: props.gochiUseDateFrom,
          gochiUseDateTo: props.gochiUseDateTo,
          gochiBillNo: props.gochiBillNo,
          shopId: props.shopId,
          menuId: props.menuId,
          depositPlan: props.depositPlan,
          page,
          limit: limit || limitNum
        };

        props.updateLoading(true);
        props.updateOpenProgress(true);
        props.actions
          .getGochis(searchKey)
          .then(data => {
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
            props.updateOpenTable(true);
          })
          .catch(() => {
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
          });
      }
      props.setPage(page);
    },
    loadGochiData: props => page => {
      setTimeout(() => {
        props.updateLoading(true);
        props.updateOpenProgress(true);
        const searchKey = {
          menuName: props.menuName,
          menuId: props.menuId,
          userName: props.userName,
          gochiBillNo: props.gochiBillNo,
          gochiType: props.gochiType,
          gochiUserType: props.gochiUserType,
          gochiDateFrom: props.gochiDateFrom,
          gochiDateTo: props.gochiDateTo,
          gochiStatus: props.gochiStatus,
          gochiUseDateFrom: props.gochiUseDateFrom,
          gochiUseDateTo: props.gochiUseDateTo,
          depositPlan: props.depositPlan,
          limit: 10,
          page
        };
        // let list = [];
        // if (page > 1) {
        //   list = props.listGochi;
        // } else {
        //   list = [];
        //   props.setNextHref(1);
        // }

        // if (searchFlag) {
        props.actions
          .getGochisShop(searchKey)
          .then(data => {
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            props.updateOpenProgress(false);
            props.updateLoading(false);

            let list = [];
            if (page > 1) {
              list = props.listGochi;
            } else {
              list = [];
              props.setNextHref(1);
            }

            if (data.type === 'GET_GOCHIS_SHOP_SUCCESS') {
              if (data.payload.list) {
                data.payload.list.map(gochi => {
                  return list.push(gochi);
                });
                props.setListGochi(list);
                if (data.payload.offset + 10 < data.payload.count) {
                  props.setHasMore(true);
                } else {
                  props.setHasMore(false);
                }
              }
            }

            // if (data.type === 'GET_GOCHIS_SHOP_SUCCESS') {
            //   if (data.payload.result) {
            //     props.setGochisAll(data.payload.result);
            //     for (let i = 0; i < data.payload.result.length; i += 1) {
            //       if (i < props.perPage) {
            //         list.push(data.payload.result[i]);
            //       }
            //     }
            //     // data.payload.gochisAll.map(gochis => {
            //     //   return list.push(gochis);
            //     // });
            //     props.setListGochi(list);
            //     if (data.payload.result.length > props.perPage) {
            //       props.setHasMore(true);
            //     } else {
            //       props.setHasMore(false);
            //     }
            //   }
            // }
          })
          .catch(error => {
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
            console.log('error', error);
            props.setNextHref(1);
          });
        // } else {
        //   for (let i = 0; i < props.gochisAll.length; i += 1) {
        //     if (i < page * props.perPage && i >= (page - 1) * props.perPage) {
        //       list.push(props.gochisAll[i]);
        //       if (list.length - props.gochisAll.length < 0) {
        //         props.setHasMore(true);
        //       } else {
        //         props.setHasMore(false);
        //       }
        //       props.setListGochi(list);
        //       props.updateOpenProgress(false);
        //       props.setResultMessage('');
        //       props.updateLoading(false);
        //     }
        //   }
        // }
      }, 100);
    },
    generateRandomString: props => (length = 32) => {
      let text = '';
      const possible =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

      for (let i = 0; i < length; i += 1) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }

      console.log('crfs token', text);
      props.setCrfsToken(text);
      return text;
    }
  }),
  lifecycle({
    async componentWillMount() {
      if (
        this.props.location.state &&
        this.props.location.state.viewClassicMode
      ) {
        this.props.setViewClassicMode(true);
        this.props.updateOpenTable(true);
        this.props.handleChangePage(null, 1, 100, true);
      }
    },
    async componentDidMount() {
      this.props.generateRandomString();
      this.props.setChildKey(this.props.childKey + 1);
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' });
      // this.props.loadGochiData(1, true);
      // this.props.handleChangePage(null, 0);
    },
    componentUnmount() {
      const list = [{ foo: undefined }];
      this.props.setListGochi(list);
      console.log(this.props.listGochi);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    handleChangePage,
    account,
    gochiStatuses,
    gochiTypes,
    gochiUserTypes,
    // openDrawer,
    updateOpenDrawer,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    setResultMessage,
    menuName,
    setMenuName,
    userName,
    setUserName,
    gochiType,
    setGochiType,
    gochiBillNo,
    setGochiBillNo,
    gochiUserType,
    setGochiUserType,
    gochiDateFrom,
    setGochiDateFrom,
    gochiDateTo,
    setGochiDateTo,
    gochiStatus,
    setGochiStatus,
    gochiUseDateFrom,
    setGochiUseDateFrom,
    gochiUseDateTo,
    setGochiUseDateTo,
    gochiUseDateEnableFlg,
    setGochiUseDateEnableFlg,
    handleRedirect,
    hasMore,
    loadGochiData,
    messageReply,
    setMessageReply,
    listGochi,
    shopReplyText,
    setShopReplyText,
    childKey,
    setListGochi,
    nextHref,
    setNextHref,
    menuId,
    setMenuId,
    textTitle,
    setTextTitle,
    textMessage,
    setTextMessage,
    openNotifyPopup,
    setOpenNotifyPopup,
    expandedCollapse,
    setExpandedCollapse,
    isShashoku,
    setIsShashoku,
    viewClassicMode,
    setViewClassicMode,
    setPage,
    openTable,
    updateOpenTable,
    page,
    depositPlan,
    setDepositPlan,
    shashokuShopReplyText,
    setShashokuShopReplyText,
    shashokuMessageReply,
    setShashokuMessageReply,
    openPopupCsv,
    setOpenPopupCsv,
    isZip,
    setIsZip,
    isGochiKid,
    setIsGochiKid,
    showUpdateAmountHistoryModal,
    setShowUpdateAmountHistoryModal,
    updateAmountHistoryDetail,
    setUpdateAmountHistoryDetail,
    showUpdateAmountModal,
    setShowUpdateAmountModal,
    gochiChoseUpdateAmount,
    setGochiChoseUpdateAmount,
    couponGochiChoseUpdateAmount,
    systemNameGochiChoseUpdateAmount,
    setSystemNameGochiChoseUpdateAmount,
    oldAmountUpdateAmount,
    setOldAmountUpdateAmount,
    setCouponGochiChoseUpdateAmount,
    maxAmountCanUpdate,
    setMaxAmountCanUpdate,
    amountUpdated,
    setAmountUpdated,
    amountUpdatedError,
    setAmountUpdatedError,
    showUpdateAmountConfirmModal,
    setShowUpdateAmountConfirmModal,
    showUpdateAmountSuccessModal,
    setShowUpdateAmountSuccessModal,
    history,
    crfsToken,
    generateRandomString,
    location
  }) => {
    const isFukuoka =
      typeof account !== 'undefined' && account.fukuokaFlag === 1;
    const isNaha = typeof account !== 'undefined' && account.nahaFlag === 1;
    const educateSystem =
      typeof account !== 'undefined' && account.educateSystem;
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const isDeveloper =
      typeof account !== 'undefined' && account.role === 'DEVELOPER';
    const roles = {
      isShop,
      isGroup,
      isSecretariat,
      isDeveloper
    };

    const rowsPerPage = document.getElementById('rowsPerPage');
    let limit = 100;
    if (rowsPerPage) {
      limit = rowsPerPage.textContent;
    }

    let searchKey = {
      menuName,
      userName,
      gochiType,
      gochiUserType,
      gochiDateFrom,
      gochiDateTo,
      gochiStatus,
      gochiUseDateFrom,
      gochiUseDateTo,
      gochiBillNo,
      depositPlan,
      menuId,
      limit: viewClassicMode ? limit : 10
    };

    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;

    const para = queryString.parse(window.location.search);
    // check if is account shop
    if (!isShop && !isReleased && !para.notify) {
      console.log('isShop', isShop);
      console.log('isReleased', isReleased);
      console.log('para.notify', para.notify);
      handleRedirect('/shops');
    }

    const searchActionClassic = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      setPage(1);
      await actions
        .getGochis(searchKey)
        .then(data => {
          checkSession(data);
          updateOpenProgress(false);
          setResultMessage('');
          updateLoading(false);
          // handleChangePage(null, 0);
          updateOpenTable(true);
        })
        .catch(() => {
          updateOpenProgress(false);
          setResultMessage('');
          updateLoading(false);
        });
    };

    const searchAction = () => {
      setExpandedCollapse(false);
      setListGochi([]);
      setNextHref(1);

      searchKey = {
        ...searchKey
      };
      loadGochiData(1, true);
    };

    useEffect(() => {
      if (!location.state || !location.state.viewClassicMode) searchAction();
    }, [para.notify]);

    const loadMoreGochis = () => {
      setNextHref(nextHref + 1);
      searchKey = {
        ...searchKey
      };
      loadGochiData(nextHref + 1);
    };

    const downloadCsvBlob = (blob, fileName, isZipP) => {
      const blobC = new Blob([blob], {
        type: isZipP ? 'application/zip' : 'text/csv'
      });
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(blobC, fileName);
      } else {
        // for chrome, firefox
        const url = URL.createObjectURL(blobC);
        const linkEl = document.createElement('a');
        linkEl.href = url;
        linkEl.setAttribute('download', fileName);
        document.body.appendChild(linkEl);
        linkEl.click();

        linkEl.parentNode.removeChild(linkEl);
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);
      }
    };

    const csvDownloadAction = async isZipP => {
      updateLoading(true);
      updateOpenProgress(true);
      let fileType = '';
      const params = { ...searchKey };
      if (isZipP) {
        params.isZip = 1;
        fileType = '.csv.zip';
      } else {
        params.isZip = 0;
        fileType = '.csv';
      }
      const response = await actions
        .downloadGochiShop(params)
        .then(data => checkSession(data));
      if (response.type === 'DOWNLOAD_GOCHIS_SHOP_SUCCESS') {
        const timeStamp = moment()
          .tz('Asia/Tokyo')
          .format('YYYYMMDDHHmm');
        updateOpenProgress(false);
        setResultMessage('');
        updateLoading(false);
        const csvName = !isFukuoka ? '_gochi_info' : '_coupon_info';
        downloadCsvBlob(
          response.payload,
          `${timeStamp}${csvName}${fileType}`,
          isZipP
        );
      } else {
        setResultMessage(
          'ファイル容量が想定量を超えたため、ダウンロードに失敗しました。\n恐れ入りますが、期間を短く設定し直してから再度ダウンロードを実行ください。'
        );
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    const shopReplyMessage = async gochiBillId => {
      updateOpenProgress(true);
      updateLoading(true);
      const params = {
        gochiBillId,
        message: messageReply[gochiBillId]
      };
      const tempReply = { ...shopReplyText };
      await actions.postShopReply(params).then(data => {
        checkSession(data);
        updateOpenProgress(false);
        setResultMessage('');
        updateLoading(false);

        if (data.type === 'SHOP_REPLY_SUCCESS') {
          setMessageReply({});

          tempReply[gochiBillId] = data.payload.shopReplyMessage;

          setShopReplyText(tempReply);
          setTextTitle('メール送信完了');
          setTextMessage('感謝のメッセージを送りました。');
          setOpenNotifyPopup(true);
        } else {
          setTextTitle('メール送信エラー');
          setTextMessage(
            'ユーザ様の入力したメールアドレスが間違っていますので、感謝のメッセージが送れません。ご了承ください。'
          );
          setOpenNotifyPopup(true);
        }
      });
      updateOpenProgress(false);
      updateLoading(false);
    };

    const shopShashokuReplyMessage = async shashokuTicketShopMessageId => {
      updateOpenProgress(true);
      updateLoading(true);
      const params = {
        shashokuTicketShopMessageId,
        shopReplyMessage: shashokuMessageReply[shashokuTicketShopMessageId]
      };
      const tempReply = { ...shashokuShopReplyText };
      await actions.postShashokuShopReply(params).then(data => {
        checkSession(data);
        updateOpenProgress(false);
        updateLoading(false);

        if (data.type === 'SHASHOKU_SHOP_REPLY_SUCCESS') {
          setShashokuMessageReply({});

          tempReply[shashokuTicketShopMessageId] =
            shashokuMessageReply[shashokuTicketShopMessageId];

          setShashokuShopReplyText(tempReply);
          setTextTitle('メール送信完了');
          setTextMessage('感謝のメッセージを送りました。');
          setOpenNotifyPopup(true);
        } else {
          setTextTitle('メール送信エラー');
          setTextMessage(
            'ユーザ様の入力したメールアドレスが間違っていますので、感謝のメッセージが送れません。ご了承ください。'
          );
          setOpenNotifyPopup(true);
        }
      });
      updateOpenProgress(false);
      updateLoading(false);
    };
    const tempObj1 = {};
    const onChangeShashokuReplyMess = (
      message,
      shashokuTicketShopMessageId
    ) => {
      tempObj1[shashokuTicketShopMessageId] = message;
      setShashokuMessageReply(tempObj1);
    };

    const tempObj = {};
    const onChangeReplyMess = (message, gochiBillId) => {
      tempObj[gochiBillId] = message;
      setMessageReply(tempObj);
    };

    const handleChangeGochiType = e => {
      setGochiType(e);
      if (e === 'SHASHOKU') {
        setIsShashoku(true);
        setGochiDateFrom('');
        setGochiDateTo('');
        setGochiUserType('');
        setGochiBillNo('');
      } else if (e === 'GOCHI_KID') {
        setIsGochiKid(true);
        setGochiDateFrom('');
        setGochiDateTo('');
        setGochiUserType('');
        setGochiBillNo('');
      } else {
        setIsShashoku(false);
        setIsGochiKid(false);
        setGochiDateFrom(() => {
          moment.tz.setDefault('Asia/Tokyo');
          return moment()
            .date(1)
            .format('YYYY-MM-DD');
        });
        setGochiDateTo(() => {
          return moment()
            .endOf('month')
            .format('YYYY-MM-DD');
        });
      }
    };

    const changeToClassicViewMode = () => {
      console.log('Change to classic view mode');
      setViewClassicMode(true);
      updateOpenTable(true);
      handleChangePage(null, 1, 100, true);
    };

    const changeToResponsiveViewMode = () => {
      console.log('Change to classic view mode');
      setViewClassicMode(false);
      searchAction();
    };

    const cancelCsvAction = () => {
      setOpenPopupCsv(false);
      setIsZip(false);
    };

    const downloadCsvAction = () => {
      setOpenPopupCsv(false);
      csvDownloadAction(isZip);
    };

    const openUpdateAmountHistory = async (couponId, shashokuTicketId) => {
      updateLoading(true);
      updateOpenProgress(true);
      const response = await actions
        .getUpdateAmountHistoryDetail({ couponId, shashokuTicketId })
        .then(data => checkSession(data));

      if (response.type === GET_UPDATE_AMOUNT_HISTORY_DETAIL_SUCCESS) {
        setUpdateAmountHistoryDetail(response.payload);
        setShowUpdateAmountHistoryModal(true);
        updateLoading(false);
        updateOpenProgress(false);
      } else {
        updateLoading(false);
        setResultMessage('エラーが発生しました！');
      }
    };

    const openUpdateAmountModal = async (gochi, coupon) => {
      updateLoading(true);
      updateOpenProgress(true);
      let params = null;

      if (gochi.sourceTable === 'SHASHOKU') {
        params = {
          shashokuTicketId: gochi.shashokuTicketId,
          couponId: null
        };
      } else if (
        gochi.sourceTable === 'GOCHI' &&
        gochi.gochiTypeStr === gochiTypes[4].name
      ) {
        params = {
          shashokuTicketId: null,
          couponId: coupon.couponId
        };
      }

      const response = await actions
        .getRemainAmountUpdateAmount(params)
        .then(data => checkSession(data));

      if (response.type === GET_REMAIN_AMOUNT_UPDATE_AMOUNT_SUCCESS) {
        updateLoading(false);
        updateOpenProgress(false);
        setGochiChoseUpdateAmount(gochi);
        setAmountUpdatedError('');
        setSystemNameGochiChoseUpdateAmount(response.payload.eduSystem);

        if (gochi.sourceTable === 'SHASHOKU') {
          setCouponGochiChoseUpdateAmount(null);
          setOldAmountUpdateAmount(gochi.amountTransferToShopWhenUseShashoku);
          setMaxAmountCanUpdate(gochi.amountTransferToShopWhenUseShashoku);

          if (gochi.menuId) {
            setAmountUpdated(0);
            generateRandomString();
            setShowUpdateAmountConfirmModal(true);
          } else {
            setAmountUpdated(null);
            setShowUpdateAmountModal(true);
          }
        } else if (
          gochi.sourceTable === 'GOCHI' &&
          gochi.gochiTypeStr === gochiTypes[4].name
        ) {
          setAmountUpdated(null);
          setShowUpdateAmountModal(true);
          setCouponGochiChoseUpdateAmount(coupon);
          setOldAmountUpdateAmount(coupon.amountTransferToShopWhenUse);
          setMaxAmountCanUpdate(coupon.amountTransferToShopWhenUse);
        }
      } else {
        updateLoading(false);
        setResultMessage('エラーが発生しました！');
      }
    };

    const validAmountUpdated = () => {
      const value = amountUpdated;
      if (value === '') {
        setAmountUpdatedError('必須項目です。');
        return 1;
      }

      if (!/^\d+$/.test(value)) {
        setAmountUpdatedError('半角数字のみ入力してください。');
        return 1;
      }

      if (parseInt(value, 10) > maxAmountCanUpdate) {
        setAmountUpdatedError(
          '※現在のクーポン利用額（合計）以下の金額に編集してください。'
        );
        return 1;
      }

      if (parseInt(value, 10) === maxAmountCanUpdate) {
        setAmountUpdatedError('修正金額を正しく入力してください。');
        return 1;
      }

      setAmountUpdatedError('');
      setAmountUpdated(parseInt(value, 10));
      return 0;
    };

    const confirmUpdateAmount = () => {
      let errorCount = 0;
      errorCount = validAmountUpdated();

      if (errorCount === 0) {
        setShowUpdateAmountModal(false);
        generateRandomString();
        setShowUpdateAmountConfirmModal(true);
      }
    };

    const backConfirmUpdateAmount = () => {
      setShowUpdateAmountConfirmModal(false);

      if (
        (gochiChoseUpdateAmount.sourceTable === 'SHASHOKU' &&
          !gochiChoseUpdateAmount.menuId) ||
        (gochiChoseUpdateAmount.sourceTable === 'GOCHI' &&
          gochiChoseUpdateAmount.gochiTypeStr === gochiTypes[4].name)
      ) {
        setShowUpdateAmountModal(true);
      }
    };

    const editAmountEducationSystem = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      let params = null;

      if (gochiChoseUpdateAmount.sourceTable === 'SHASHOKU') {
        params = {
          shashokuTicketId: gochiChoseUpdateAmount.shashokuTicketId,
          couponId: null,
          newAmount: amountUpdated
        };
      } else if (
        gochiChoseUpdateAmount.sourceTable === 'GOCHI' &&
        gochiChoseUpdateAmount.gochiTypeStr === gochiTypes[4].name
      ) {
        params = {
          shashokuTicketId: null,
          couponId: couponGochiChoseUpdateAmount.couponId,
          newAmount: amountUpdated
        };
      }

      const response = await actions
        .updateAmountEducationSystem(params, crfsToken)
        .then(data => checkSession(data));

      if (response.type === UPDATE_AMOUNT_EDUCATION_SYSTEM_SUCCESS) {
        generateRandomString();
        setShowUpdateAmountSuccessModal(true);
        setShowUpdateAmountConfirmModal(false);
        updateLoading(false);
        updateOpenProgress(false);
      } else {
        updateLoading(false);
        if (
          response.error &&
          response.payload.data &&
          response.payload.data.errorInfo &&
          response.payload.data.errorInfo.code ===
            'exception.errors.security.has.csrf.token'
        ) {
          generateRandomString();
          setResultMessage('処理中ですのでしばらくお待ちください。');
        } else {
          setResultMessage('エラーが発生しました！');
        }
      }
    };

    const handleCloseUpdateAmountSuccessModal = () => {
      if (viewClassicMode) {
        handleChangePage(null, page, null, true);
      } else {
        searchAction();
      }

      setShowUpdateAmountSuccessModal(false);
    };

    console.log('listGochilistGochilistGochi', listGochi);

    return (
      <>
        {!viewClassicMode && (
          <div className={classes.root}>
            <Header
              onMenuClick={() => {
                updateOpenDrawer(true);
              }}
            />

            <div className={classes.mainContent}>
              <div className={classes.pageTitileDiv}>
                <Typography color="textPrimary" className={classes.fs24}>
                  {isFukuoka ? 'クーポン情報管理' : 'ごち情報管理'}
                </Typography>
              </div>
              <div className={classes.searchCollapseBox}>
                <Accordion
                  className={classes.boxCollapse}
                  expanded={expandedCollapse}
                  onChange={() => {
                    setExpandedCollapse(!expandedCollapse);
                  }}
                >
                  <div className={classes.textTitleDiv}>
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon className={classes.arrowCustom} />
                      }
                      aria-controls="statistic-pannel"
                      id="statistic-pannel"
                      className={classes.collapseBtn}
                    >
                      <Typography
                        color="textSecondary"
                        className={[classes.fs20, classes.extendClasses]}
                      >
                        {isFukuoka ? '詳細検索' : 'ごち検索'}
                      </Typography>
                    </AccordionSummary>
                  </div>

                  <AccordionDetails>
                    <Paper className={classes.mainPaper} elevation={1}>
                      <div className={classes.searchForm}>
                        <div>
                          <TextField
                            label={isFukuoka ? 'コース名' : 'メニュー名'}
                            placeholder="部分一致"
                            type="search"
                            className={classes.textField}
                            margin="normal"
                            value={menuName}
                            onChange={e => {
                              setMenuName(e.target.value);
                            }}
                          />
                          {!isFukuoka && (
                            <>
                              {' '}
                              <TextField
                                select
                                label="チケット種別"
                                className={classes.textField}
                                margin="normal"
                                value={gochiType}
                                onChange={e => {
                                  handleChangeGochiType(e.target.value);
                                }}
                                InputLabelProps={{
                                  shrink: true
                                }}
                              >
                                {gochiTypes.map(type => {
                                  return (
                                    <MenuItem key={type.id} value={type.id}>
                                      {type.name}
                                    </MenuItem>
                                  );
                                })}
                              </TextField>
                              <TextField
                                select
                                label="使用者種別"
                                className={classes.textField}
                                margin="normal"
                                disabled={isShashoku || isGochiKid}
                                value={gochiUserType}
                                onChange={e => {
                                  setGochiUserType(e.target.value);
                                }}
                                InputLabelProps={{
                                  shrink: true
                                }}
                              >
                                {gochiUserTypes.map(type => {
                                  return (
                                    <MenuItem key={type.id} value={type.id}>
                                      {type.name}
                                    </MenuItem>
                                  );
                                })}
                              </TextField>
                            </>
                          )}
                        </div>
                        <div>
                          {!isFukuoka && (
                            <TextField
                              label="購入者名"
                              placeholder="部分一致"
                              type="search"
                              className={classes.textField}
                              margin="normal"
                              value={userName}
                              onChange={e => {
                                setUserName(e.target.value);
                              }}
                            />
                          )}
                        </div>
                        <div>
                          <TextField
                            label={gts('購入日(From)', educateSystem)}
                            type="date"
                            className={classes.textField150}
                            margin="normal"
                            InputLabelProps={{
                              shrink: true
                            }}
                            disabled={isShashoku || isGochiKid}
                            value={gochiDateFrom}
                            onChange={e => {
                              setGochiDateFrom(e.target.value);
                            }}
                          />
                          <TextField
                            label={gts('購入日(To)', educateSystem)}
                            type="date"
                            className={classes.textField150}
                            margin="normal"
                            InputLabelProps={{
                              shrink: true
                            }}
                            disabled={isShashoku || isGochiKid}
                            value={gochiDateTo}
                            onChange={e => {
                              setGochiDateTo(e.target.value);
                            }}
                          />
                        </div>
                        <div>
                          {!isFukuoka && (
                            <TextField
                              select
                              label="使用状況"
                              className={classes.textField}
                              margin="normal"
                              value={gochiStatus}
                              onChange={e => {
                                setGochiStatus(e.target.value);
                                if (
                                  e.target.value === '' ||
                                  e.target.value === 'USED'
                                ) {
                                  setGochiUseDateEnableFlg(true);
                                } else {
                                  setGochiUseDateFrom('');
                                  setGochiUseDateTo('');
                                  setGochiUseDateEnableFlg(false);
                                }
                              }}
                              InputLabelProps={{
                                shrink: true
                              }}
                            >
                              {gochiStatuses.map(status => {
                                return (
                                  <MenuItem key={status.id} value={status.id}>
                                    {status.name}
                                  </MenuItem>
                                );
                              })}
                            </TextField>
                          )}
                          <TextField
                            label="使用日(From)"
                            type="date"
                            className={classes.textField150}
                            margin="normal"
                            InputLabelProps={{
                              shrink: true
                            }}
                            disabled={!gochiUseDateEnableFlg}
                            value={gochiUseDateFrom}
                            onChange={e => {
                              setGochiUseDateFrom(e.target.value);
                            }}
                          />
                          <TextField
                            label="使用日(To)"
                            type="date"
                            className={classes.textField150}
                            margin="normal"
                            InputLabelProps={{
                              shrink: true
                            }}
                            disabled={!gochiUseDateEnableFlg}
                            value={gochiUseDateTo}
                            onChange={e => {
                              setGochiUseDateTo(e.target.value);
                            }}
                          />
                        </div>
                        <div className={classes.textLeft}>
                          <SearchButton onClickAction={searchAction} />
                        </div>
                      </div>
                    </Paper>
                  </AccordionDetails>
                </Accordion>
              </div>

              <Paper>
                <div className={classes.buttonCenter}>
                  <ViewClassicModeButton
                    onClickAction={changeToClassicViewMode}
                  />
                  {account.fukuokaFlag || isNaha ? (
                    <>
                      <CsvDownloadShopButton
                        title="検索結果出力（CSV形式）"
                        onClickAction={() => {
                          setIsZip(false);
                          setOpenPopupCsv(true);
                        }}
                      />
                      <CsvDownloadShopButton
                        title="検索結果出力（ZIP形式）"
                        onClickAction={() => {
                          setIsZip(true);
                          setOpenPopupCsv(true);
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <CsvDownloadShopButton
                        title="検索結果出力（CSV形式）"
                        onClickAction={() => {
                          csvDownloadAction(false);
                        }}
                      />
                      <CsvDownloadShopButton
                        title="検索結果出力（ZIP形式）"
                        onClickAction={() => {
                          csvDownloadAction(true);
                        }}
                      />
                    </>
                  )}
                  <div className={classes.textNoteCsv}>
                    ※CSV形式でダウンロードができない場合はZIP形式をお試しください。
                    <br />
                    ZIP形式の説明は
                    <a
                      className={classes.textLinkCsv}
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://shop-guide.gochimeshi.com/individual/p16028/"
                    >
                      こちら
                    </a>
                  </div>
                </div>
                <div className={classes.infiniteScroll}>
                  <div
                    className="select-block-body m-0"
                    key={`box${childKey}`}
                    // style={{ height: '1000px', overflow: 'auto' }}
                  >
                    <div className="lst-friends h-100" key={`list${childKey}`}>
                      {listGochi &&
                        listGochi.map(gochi => {
                          const key =
                            gochi.sourceTable === 'GOCHI'
                              ? `${gochi.gochiBillId}-${gochi.sourceTable}`
                              : `${gochi.shashokuTicketId}-${
                                  gochi.sourceTable
                                }`;
                          return (
                            <>
                              {gochi.sourceTable === 'SHASHOKU' && (
                                <div className={classes.gochiBox} key={key}>
                                  <div
                                    className={classNames(
                                      classes.remainCoupon,
                                      classes.gochiHeader
                                    )}
                                  >
                                    <span>
                                      <b>
                                        {isFukuoka
                                          ? '電子クーポン利用状況'
                                          : '社食チケット利用状況'}
                                      </b>
                                    </span>
                                  </div>

                                  <Table>
                                    <TableBody className={classes.tableInfo}>
                                      <TableRow
                                        className={classes.tableInfoRow}
                                      >
                                        <TableCell
                                          className={
                                            classes.tableInfoCellHeader
                                          }
                                        >
                                          利用日
                                        </TableCell>
                                        <TableCell
                                          className={classes.tableInfoCell}
                                        >
                                          {gochi.useDate}
                                        </TableCell>
                                      </TableRow>
                                      {!isFukuoka && (
                                        <TableRow>
                                          <TableCell
                                            className={
                                              classes.tableInfoCellHeader
                                            }
                                          >
                                            法人名
                                          </TableCell>
                                          <TableCell
                                            className={classes.tableInfoCell}
                                          >
                                            {gochi.companyName ||
                                              gochi.connectSystemName}
                                          </TableCell>
                                        </TableRow>
                                      )}
                                      {(!!account.fukuokaFlag || isNaha) && ( // hardcode check for system 37 fukuoka and system Naha
                                        <>
                                          <TableRow>
                                            <TableCell
                                              className={
                                                classes.tableInfoCellHeader
                                              }
                                            >
                                              利用者名
                                            </TableCell>
                                            <TableCell
                                              className={classes.tableInfoCell}
                                            >
                                              {gochi.shashokuUserName}
                                            </TableCell>
                                          </TableRow>
                                        </>
                                      )}
                                      <TableRow>
                                        <TableCell
                                          className={
                                            classes.tableInfoCellHeader
                                          }
                                        >
                                          {isFukuoka
                                            ? 'コース名'
                                            : 'メニュー名'}
                                        </TableCell>
                                        <TableCell
                                          className={classes.tableInfoCell}
                                        >
                                          {gochi.menuName}
                                        </TableCell>
                                      </TableRow>
                                      <TableRow>
                                        <TableCell
                                          className={
                                            classes.tableInfoCellHeader
                                          }
                                        >
                                          <div>
                                            {isFukuoka
                                              ? '振込額'
                                              : '使用時の店舗振込額'}
                                          </div>
                                          {gochi.showHistoryFlag &&
                                          isFukuoka ? (
                                            <Button
                                              className={
                                                classes.btnUpdateAmountHistory
                                              }
                                              onClick={() => {
                                                openUpdateAmountHistory(
                                                  null,
                                                  gochi.shashokuTicketId
                                                );
                                              }}
                                            >
                                              金額修正履歴
                                            </Button>
                                          ) : null}
                                        </TableCell>
                                        <TableCell
                                          className={classes.tableInfoCell}
                                        >
                                          <div>
                                            {gochi.amountTransferToShopWhenUseShashoku &&
                                              gochi.amountTransferToShopWhenUseShashoku.toLocaleString()}
                                            {`円`}
                                          </div>
                                          {gochi.editAmountFlag &&
                                          isFukuoka &&
                                          gochi.amountTransferToShopWhenUseShashoku ? (
                                            <Button
                                              className={
                                                classes.btnUpdateAmount
                                              }
                                              onClick={() => {
                                                openUpdateAmountModal(
                                                  gochi,
                                                  null
                                                );
                                              }}
                                            >
                                              金額修正
                                            </Button>
                                          ) : null}
                                        </TableCell>
                                      </TableRow>
                                      {!isFukuoka && (
                                        <TableRow>
                                          <TableCell
                                            className={
                                              classes.tableInfoCellHeader
                                            }
                                          >
                                            入金予定
                                          </TableCell>
                                          <TableCell
                                            className={classes.tableInfoCell}
                                          >
                                            {gochi.depositPlanStr}
                                          </TableCell>
                                        </TableRow>
                                      )}
                                      <TableRow>
                                        <TableCell
                                          className={
                                            classes.tableInfoCellHeader
                                          }
                                        >
                                          コメント
                                        </TableCell>
                                        <TableCell
                                          className={classes.tableInfoCell}
                                        >
                                          {gochi.gochiMessage}
                                        </TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>

                                  <div className={classes.lstMessage}>
                                    {gochi.shashokuShopMessage &&
                                      gochi.shashokuShopMessage.shopMessage && (
                                        <div className={classes.boxMessage}>
                                          <b className={classes.messageTtl}>
                                            {isFukuoka
                                              ? '教室への連絡'
                                              : '店舗へのメッセージ'}
                                          </b>
                                          <div className={classes.messageTxt}>
                                            <ReadMoreReact
                                              text={
                                                gochi.shashokuShopMessage
                                                  .shopMessage
                                              }
                                              min={60}
                                              ideal={65}
                                              max={66}
                                              readMoreText="もっと見る"
                                            />
                                          </div>
                                        </div>
                                      )}

                                    {gochi.shashokuShopMessage &&
                                      gochi.shashokuShopMessage.shopMessage &&
                                      !isFukuoka && (
                                        <div
                                          className={classes.boxMessageReply}
                                        >
                                          <b className={classes.messageTtl}>
                                            <ReplyIcon
                                              className={classes.iconReply}
                                            />
                                            感謝のメッセージ
                                            {!gochi.shashokuShopMessage
                                              .shopReplyMessage &&
                                              !shashokuShopReplyText[
                                                gochi.shashokuShopMessage
                                                  .shashokuTicketShopMessageId
                                              ] && (
                                                <Button
                                                  variant="contained"
                                                  color="primary"
                                                  size="xs"
                                                  className={classes.buttonSend}
                                                  onClick={() => {
                                                    shopShashokuReplyMessage(
                                                      gochi.shashokuShopMessage
                                                        .shashokuTicketShopMessageId
                                                    );
                                                  }}
                                                >
                                                  送信
                                                </Button>
                                              )}
                                          </b>

                                          {gochi.shashokuShopMessage
                                            .shopReplyMessage ? (
                                            // eslint-disable-next-line react/jsx-indent
                                            <div
                                              className={
                                                classes.messageReplyBox
                                              }
                                            >
                                              <ReadMoreReact
                                                text={
                                                  gochi.shashokuShopMessage
                                                    .shopReplyMessage
                                                }
                                                min={60}
                                                ideal={65}
                                                max={66}
                                                readMoreText="もっと見る"
                                              />
                                            </div>
                                          ) : (
                                            [
                                              shashokuShopReplyText[
                                                gochi.shashokuShopMessage
                                                  .shashokuTicketShopMessageId
                                              ] ? (
                                                <div
                                                  className={
                                                    classes.messageReplyBox
                                                  }
                                                >
                                                  {
                                                    shashokuShopReplyText[
                                                      gochi.shashokuShopMessage
                                                        .shashokuTicketShopMessageId
                                                    ]
                                                  }
                                                </div>
                                              ) : (
                                                <div
                                                  className={classes.messageTxt}
                                                >
                                                  <TextField
                                                    id="outlined-multiline-static"
                                                    multiline
                                                    rows={4}
                                                    variant="outlined"
                                                    placeholder="例) 応援ありがとうございます。"
                                                    className={
                                                      classes.inputRoot
                                                    }
                                                    InputProps={{
                                                      className:
                                                        classes.inputMessage
                                                    }}
                                                    value={
                                                      shashokuMessageReply[
                                                        gochi
                                                          .shashokuShopMessage
                                                          .shashokuTicketShopMessageId
                                                      ]
                                                    }
                                                    onChange={e => {
                                                      onChangeShashokuReplyMess(
                                                        e.target.value,
                                                        gochi
                                                          .shashokuShopMessage
                                                          .shashokuTicketShopMessageId
                                                      );
                                                    }}
                                                  />
                                                </div>
                                              )
                                            ]
                                          )}
                                        </div>
                                      )}
                                  </div>
                                </div>
                              )}
                              {gochi.sourceTable === 'GOCHI' && (
                                <>
                                  {gochi.shopId !== null ? (
                                    <div className={classes.gochiBox} key={key}>
                                      {gochi.menuLimitTotal === 1 ? (
                                        <div
                                          className={classNames(
                                            gochi.remainAmount !== 0 &&
                                              (gochi.coupons.length > 0 &&
                                                gochi.coupons.filter(
                                                  e =>
                                                    e.gochiStatus === '期限切れ'
                                                ).length === 0) &&
                                              classes.remainCoupon,
                                            classes.gochiHeader
                                          )}
                                        >
                                          <b>使用状況 </b>
                                          <span
                                            className={classNames(
                                              classes.couponNo,
                                              gochi.remainAmount !== 0 &&
                                                (gochi.coupons.length > 0 &&
                                                  gochi.coupons.filter(
                                                    e =>
                                                      e.gochiStatus ===
                                                      '期限切れ'
                                                  ).length === 0) &&
                                                classes.textRedBig
                                            )}
                                          >
                                            {`${gochi.usedAmount}`}
                                            {`/`}
                                            {`${gochi.totalPremiumAmount} 円`}
                                          </span>
                                          <span
                                            className={classNames(
                                              classes.textCompare,
                                              gochi.remainAmount !== 0 &&
                                                (gochi.coupons.length > 0 &&
                                                  gochi.coupons.filter(
                                                    e =>
                                                      e.gochiStatus ===
                                                      '期限切れ'
                                                  ).length === 0) &&
                                                classes.textRed
                                            )}
                                          >
                                            {gochi.coupons.length > 0 &&
                                            gochi.coupons.filter(
                                              e => e.gochiStatus === '期限切れ'
                                            ).length > 0
                                              ? '期限切れ'
                                              : '使用済'}
                                          </span>
                                        </div>
                                      ) : (
                                        <div
                                          className={classNames(
                                            gochi.couponUsedCount <
                                              gochi.totalCoupon &&
                                              (gochi.coupons.length > 0 &&
                                                gochi.coupons.filter(
                                                  e =>
                                                    e.gochiStatus === '期限切れ'
                                                ).length === 0) &&
                                              classes.remainCoupon,
                                            classes.gochiHeader
                                          )}
                                        >
                                          <b>使用状況 </b>
                                          <span
                                            className={classNames(
                                              classes.couponNo,
                                              gochi.couponUsedCount <
                                                gochi.totalCoupon &&
                                                (gochi.coupons.length > 0 &&
                                                  gochi.coupons.filter(
                                                    e =>
                                                      e.gochiStatus ===
                                                      '期限切れ'
                                                  ).length === 0) &&
                                                classes.textRedBig
                                            )}
                                          >
                                            {gochi.couponUsedCount}
                                            {`/`}
                                            {gochi.totalCoupon}
                                          </span>
                                          <span
                                            className={classNames(
                                              classes.textCompare,
                                              gochi.couponUsedCount <
                                                gochi.totalCoupon &&
                                                (gochi.coupons.length > 0 &&
                                                  gochi.coupons.filter(
                                                    e =>
                                                      e.gochiStatus ===
                                                      '期限切れ'
                                                  ).length === 0) &&
                                                classes.textRed
                                            )}
                                          >
                                            {gochi.coupons.length > 0 &&
                                            gochi.coupons.filter(
                                              e => e.gochiStatus === '期限切れ'
                                            ).length > 0
                                              ? '期限切れ'
                                              : '使用済'}
                                          </span>
                                        </div>
                                      )}
                                      <Table>
                                        <TableBody
                                          className={classes.tableInfo}
                                        >
                                          <TableRow
                                            className={classes.tableInfoRow}
                                          >
                                            <TableCell
                                              className={
                                                classes.tableInfoCellHeader
                                              }
                                            >
                                              購入日
                                            </TableCell>
                                            <TableCell
                                              className={classes.tableInfoCell}
                                            >
                                              {gochi.createdAt}
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell
                                              className={
                                                classes.tableInfoCellHeader
                                              }
                                            >
                                              購入者
                                            </TableCell>
                                            <TableCell
                                              className={classes.tableInfoCell}
                                            >
                                              {gochi.registerName}
                                              {gochi.gochiRegisterAccountId !==
                                                'gcms-web-guest' && (
                                                <span
                                                  className={classes.textId}
                                                >
                                                  {`@`}
                                                  {gochi.gochiRegisterAccountId}
                                                </span>
                                              )}
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell
                                              className={
                                                classes.tableInfoCellHeader
                                              }
                                            >
                                              メニュー名
                                            </TableCell>
                                            <TableCell
                                              className={classes.tableInfoCell}
                                            >
                                              {gochi.menuName}
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell
                                              className={
                                                classes.tableInfoCellHeader
                                              }
                                            >
                                              個数
                                            </TableCell>
                                            <TableCell
                                              className={classes.tableInfoCell}
                                            >
                                              {gochi.totalCoupon}
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell
                                              className={
                                                classes.tableInfoCellHeader
                                              }
                                            >
                                              税込価格
                                            </TableCell>
                                            <TableCell
                                              className={classes.tableInfoCell}
                                            >
                                              {(
                                                gochi.amount + gochi.taxAmount
                                              ).toLocaleString()}
                                              {`円`}
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell
                                              className={
                                                classes.tableInfoCellHeader
                                              }
                                            >
                                              入金予定
                                            </TableCell>
                                            <TableCell
                                              className={classes.tableInfoCell}
                                            >
                                              {gochi.depositPlanStr}
                                            </TableCell>
                                          </TableRow>
                                          {!!gochi.subscriptionId &&
                                            enabledStripeBilling === true && (
                                              <TableRow>
                                                <TableCell
                                                  className={
                                                    classes.tableInfoCellHeader
                                                  }
                                                >
                                                  購入頻度
                                                </TableCell>
                                                <TableCell
                                                  className={
                                                    classes.tableInfoCell
                                                  }
                                                >
                                                  {`${
                                                    gochi.subscriptionIntervalCount
                                                  }${
                                                    gochi.subscriptionInterval ===
                                                    'WEEK'
                                                      ? '週間'
                                                      : 'ヶ月'
                                                  }1回`}
                                                </TableCell>
                                              </TableRow>
                                            )}
                                          <TableRow>
                                            <TableCell
                                              className={
                                                classes.tableInfoCellHeader
                                              }
                                            >
                                              店舗振込額（合計）
                                            </TableCell>
                                            <TableCell
                                              className={classes.tableInfoCell}
                                            >
                                              {gochi.totalPremiumAmountWhenBuy &&
                                                gochi.totalPremiumAmountWhenBuy.toLocaleString()}
                                              {`円`}
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell
                                              className={
                                                classes.tableInfoCellHeader
                                              }
                                            >
                                              （内訳）
                                            </TableCell>
                                            <TableCell
                                              className={classes.tableInfoCell}
                                            />
                                          </TableRow>
                                          <TableRow>
                                            <TableCell
                                              className={
                                                classes.tableInfoCellHeader
                                              }
                                            >
                                              購入金額
                                            </TableCell>
                                            <TableCell
                                              className={classes.tableInfoCell}
                                            >
                                              {gochi.totalNotPremiumAmountWhenBuy &&
                                                gochi.totalNotPremiumAmountWhenBuy.toLocaleString()}
                                              {`円`}
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell
                                              className={
                                                classes.tableInfoCellHeader
                                              }
                                            >
                                              プレミアム金額
                                            </TableCell>
                                            <TableCell
                                              className={classes.tableInfoCell}
                                            >
                                              {gochi.onlyPremiumAmountWhenBuy &&
                                                gochi.onlyPremiumAmountWhenBuy.toLocaleString()}
                                              {`円`}
                                            </TableCell>
                                          </TableRow>
                                        </TableBody>
                                      </Table>

                                      <div className={classes.lstMessage}>
                                        {gochi.shopMessage && (
                                          <div className={classes.boxMessage}>
                                            <b className={classes.messageTtl}>
                                              店舗へのメッセージ
                                            </b>
                                            <div className={classes.messageTxt}>
                                              <ReadMoreReact
                                                text={gochi.shopMessage}
                                                min={60}
                                                ideal={65}
                                                max={66}
                                                readMoreText="もっと見る"
                                              />
                                            </div>
                                          </div>
                                        )}

                                        {gochi.shopMessage && (
                                          <div
                                            className={classes.boxMessageReply}
                                          >
                                            <b className={classes.messageTtl}>
                                              <ReplyIcon
                                                className={classes.iconReply}
                                              />
                                              感謝のメッセージ
                                              {!gochi.shopReplyMessage &&
                                                !shopReplyText[
                                                  gochi.gochiBillId
                                                ] && (
                                                  <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="xs"
                                                    className={
                                                      classes.buttonSend
                                                    }
                                                    onClick={() => {
                                                      shopReplyMessage(
                                                        gochi.gochiBillId
                                                      );
                                                    }}
                                                  >
                                                    送信
                                                  </Button>
                                                )}
                                            </b>

                                            {gochi.shopReplyMessage ? (
                                              <div
                                                className={
                                                  classes.messageReplyBox
                                                }
                                              >
                                                <ReadMoreReact
                                                  text={gochi.shopReplyMessage}
                                                  min={60}
                                                  ideal={65}
                                                  max={66}
                                                  readMoreText="もっと見る"
                                                />
                                              </div>
                                            ) : (
                                              [
                                                shopReplyText[
                                                  gochi.gochiBillId
                                                ] ? (
                                                  <div
                                                    className={
                                                      classes.messageReplyBox
                                                    }
                                                  >
                                                    {
                                                      shopReplyText[
                                                        gochi.gochiBillId
                                                      ]
                                                    }
                                                  </div>
                                                ) : (
                                                  <div
                                                    className={
                                                      classes.messageTxt
                                                    }
                                                  >
                                                    <TextField
                                                      id="outlined-multiline-static"
                                                      multiline
                                                      rows={4}
                                                      // defaultValue="Default Value"
                                                      variant="outlined"
                                                      placeholder="例) 応援ありがとうございます。"
                                                      className={
                                                        classes.inputRoot
                                                      }
                                                      InputProps={{
                                                        className:
                                                          classes.inputMessage
                                                      }}
                                                      value={
                                                        messageReply[
                                                          gochi.gochiBillId
                                                        ]
                                                      }
                                                      onChange={e => {
                                                        onChangeReplyMess(
                                                          e.target.value,
                                                          gochi.gochiBillId
                                                        );
                                                      }}
                                                    />
                                                  </div>
                                                )
                                              ]
                                            )}
                                          </div>
                                        )}

                                        {gochi.gochiMessage && (
                                          <div className={classes.boxMessage}>
                                            <b className={classes.messageTtl}>
                                              ごちった人のメッセージ
                                            </b>
                                            <div className={classes.messageTxt}>
                                              <ReadMoreReact
                                                text={gochi.gochiMessage}
                                                min={60}
                                                ideal={65}
                                                max={66}
                                                readMoreText="もっと見る"
                                              />
                                            </div>
                                          </div>
                                        )}

                                        {gochi.coupons &&
                                          gochi.coupons.map(coupon => {
                                            const keyCoupon = `${
                                              coupon.couponId
                                            }`;
                                            return (
                                              coupon.thanksMessage && (
                                                <div
                                                  className={classes.boxMessage}
                                                  key={keyCoupon}
                                                >
                                                  <b
                                                    className={
                                                      classes.messageTtl
                                                    }
                                                  >
                                                    ごちられた人のメッセージ
                                                  </b>
                                                  <div
                                                    className={
                                                      classes.messageTxt
                                                    }
                                                  >
                                                    <ReadMoreReact
                                                      text={
                                                        coupon.thanksMessage
                                                      }
                                                      min={60}
                                                      ideal={65}
                                                      max={66}
                                                      readMoreText="もっと見る"
                                                    />
                                                  </div>
                                                </div>
                                              )
                                            );
                                          })}
                                      </div>
                                    </div>
                                  ) : (
                                    gochi.coupons &&
                                    gochi.coupons.length > 0 &&
                                    gochi.coupons.map(coupon => {
                                      const keyCoupon = `${`coupon${
                                        coupon.couponId
                                      }`}`;
                                      const isLocalWallet =
                                        gochi.gochiTypeStr ===
                                        gochiTypes[4].name;
                                      return isLocalWallet ? (
                                        <div
                                          key={keyCoupon}
                                          className={classes.gochiBox}
                                        >
                                          <div
                                            className={classNames(
                                              classes.gochiHeader,
                                              classes.gochiCoupon,
                                              classes.gochiChargeHeader
                                            )}
                                          >
                                            <b>
                                              {isFukuoka
                                                ? 'カード型クーポン利用状況'
                                                : '地域通貨チケット利用状況'}
                                            </b>
                                          </div>

                                          <Table>
                                            <TableBody
                                              className={classes.tableInfo}
                                            >
                                              <TableRow
                                                className={classes.tableInfoRow}
                                              >
                                                <TableCell
                                                  className={
                                                    classes.tableInfoCellHeader
                                                  }
                                                >
                                                  {isFukuoka
                                                    ? '使用日時'
                                                    : '利用日'}
                                                </TableCell>
                                                <TableCell
                                                  className={
                                                    classes.tableInfoCell
                                                  }
                                                >
                                                  {coupon.useDate}
                                                </TableCell>
                                              </TableRow>
                                              {!isFukuoka && (
                                                <TableRow>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCellHeader
                                                    }
                                                  >
                                                    ごちった人
                                                  </TableCell>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCell
                                                    }
                                                  >
                                                    {gochi.registerName}
                                                    {gochi.gochiRegisterAccountId !==
                                                      'gcms-web-guest' && (
                                                      <span
                                                        className={
                                                          classes.textId
                                                        }
                                                      >
                                                        {`@`}
                                                        {
                                                          gochi.gochiRegisterAccountId
                                                        }
                                                      </span>
                                                    )}
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                              <TableRow>
                                                <TableCell
                                                  className={
                                                    classes.tableInfoCellHeader
                                                  }
                                                >
                                                  {isFukuoka
                                                    ? '利用者名'
                                                    : '利用した人'}
                                                </TableCell>
                                                <TableCell
                                                  className={
                                                    classes.tableInfoCell
                                                  }
                                                >
                                                  {coupon.gochiUserName}
                                                </TableCell>
                                              </TableRow>
                                              <TableRow>
                                                <TableCell
                                                  className={
                                                    classes.tableInfoCellHeader
                                                  }
                                                >
                                                  {isFukuoka
                                                    ? 'コース名'
                                                    : 'メニュー名'}
                                                </TableCell>
                                                <TableCell
                                                  className={
                                                    classes.tableInfoCell
                                                  }
                                                >
                                                  {gochi.menuName}
                                                </TableCell>
                                              </TableRow>

                                              <TableRow>
                                                <TableCell
                                                  className={
                                                    classes.tableInfoCellHeader
                                                  }
                                                >
                                                  <div>
                                                    {isFukuoka
                                                      ? '振込額'
                                                      : '店舗振込額（合計）'}
                                                  </div>
                                                  {coupon.showHistoryFlag &&
                                                  isFukuoka ? (
                                                    <Button
                                                      className={
                                                        classes.btnUpdateAmountHistory
                                                      }
                                                      onClick={() => {
                                                        openUpdateAmountHistory(
                                                          coupon.couponId,
                                                          null
                                                        );
                                                      }}
                                                    >
                                                      金額修正履歴
                                                    </Button>
                                                  ) : null}
                                                </TableCell>
                                                <TableCell
                                                  className={
                                                    classes.tableInfoCell
                                                  }
                                                >
                                                  <div>
                                                    {coupon.amountTransferToShopWhenUse &&
                                                      coupon.amountTransferToShopWhenUse.toLocaleString()}
                                                    {`円`}
                                                  </div>
                                                  {coupon.editAmountFlag &&
                                                  isFukuoka &&
                                                  coupon.amountTransferToShopWhenUse ? (
                                                    <Button
                                                      className={
                                                        classes.btnUpdateAmount
                                                      }
                                                      onClick={() => {
                                                        openUpdateAmountModal(
                                                          gochi,
                                                          coupon
                                                        );
                                                      }}
                                                    >
                                                      金額修正
                                                    </Button>
                                                  ) : null}
                                                </TableCell>
                                              </TableRow>
                                            </TableBody>
                                          </Table>
                                        </div>
                                      ) : (
                                        <div
                                          key={keyCoupon}
                                          className={classes.gochiBox}
                                        >
                                          <div
                                            className={classNames(
                                              classes.gochiHeader,
                                              classes.gochiCoupon
                                            )}
                                          >
                                            <b>
                                              {isFukuoka
                                                ? '紙クーポン利用状況'
                                                : '共通チケット利用状況'}
                                            </b>
                                          </div>

                                          <Table>
                                            <TableBody
                                              className={classes.tableInfo}
                                            >
                                              <TableRow
                                                className={classes.tableInfoRow}
                                              >
                                                <TableCell
                                                  className={
                                                    classes.tableInfoCellHeader
                                                  }
                                                >
                                                  {isFukuoka
                                                    ? '使用日時'
                                                    : '利用日'}
                                                </TableCell>
                                                <TableCell
                                                  className={
                                                    classes.tableInfoCell
                                                  }
                                                >
                                                  {coupon.useDate}
                                                </TableCell>
                                              </TableRow>
                                              {!isFukuoka && (
                                                <TableRow>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCellHeader
                                                    }
                                                  >
                                                    ごちった人
                                                  </TableCell>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCell
                                                    }
                                                  >
                                                    {gochi.registerName}
                                                    {gochi.gochiRegisterAccountId !==
                                                      'gcms-web-guest' && (
                                                      <span
                                                        className={
                                                          classes.textId
                                                        }
                                                      >
                                                        {`@`}
                                                        {
                                                          gochi.gochiRegisterAccountId
                                                        }
                                                      </span>
                                                    )}
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                              <TableRow>
                                                <TableCell
                                                  className={
                                                    classes.tableInfoCellHeader
                                                  }
                                                >
                                                  {isFukuoka
                                                    ? '利用者名'
                                                    : '利用した人'}
                                                </TableCell>
                                                <TableCell
                                                  className={
                                                    classes.tableInfoCell
                                                  }
                                                >
                                                  {coupon.gochiUserName}
                                                </TableCell>
                                              </TableRow>
                                              <TableRow>
                                                <TableCell
                                                  className={
                                                    classes.tableInfoCellHeader
                                                  }
                                                >
                                                  {isFukuoka
                                                    ? 'コース名'
                                                    : 'メニュー名'}
                                                </TableCell>
                                                <TableCell
                                                  className={
                                                    classes.tableInfoCell
                                                  }
                                                >
                                                  {gochi.menuName}
                                                </TableCell>
                                              </TableRow>

                                              <TableRow>
                                                <TableCell
                                                  className={
                                                    classes.tableInfoCellHeader
                                                  }
                                                >
                                                  {isFukuoka
                                                    ? '振込額'
                                                    : '店舗振込額（合計）'}
                                                </TableCell>
                                                <TableCell
                                                  className={
                                                    classes.tableInfoCell
                                                  }
                                                >
                                                  {coupon.totalPremiumAmountWhenUse &&
                                                    coupon.totalPremiumAmountWhenUse.toLocaleString()}
                                                  {`円`}
                                                </TableCell>
                                              </TableRow>
                                              {!isFukuoka && (
                                                <>
                                                  <TableRow>
                                                    <TableCell
                                                      className={
                                                        classes.tableInfoCellHeader
                                                      }
                                                    >
                                                      （内訳）
                                                    </TableCell>
                                                    <TableCell
                                                      className={
                                                        classes.tableInfoCell
                                                      }
                                                    />
                                                  </TableRow>
                                                  <TableRow>
                                                    <TableCell
                                                      className={
                                                        classes.tableInfoCellHeader
                                                      }
                                                    >
                                                      購入金額
                                                    </TableCell>
                                                    <TableCell
                                                      className={
                                                        classes.tableInfoCell
                                                      }
                                                    >
                                                      {coupon.totalNotPremiumAmountWhenUse &&
                                                        coupon.totalNotPremiumAmountWhenUse.toLocaleString()}
                                                      {`円`}
                                                    </TableCell>
                                                  </TableRow>
                                                  <TableRow>
                                                    <TableCell
                                                      className={
                                                        classes.tableInfoCellHeader
                                                      }
                                                    >
                                                      プレミアム金額
                                                    </TableCell>
                                                    <TableCell
                                                      className={
                                                        classes.tableInfoCell
                                                      }
                                                    >
                                                      {coupon.onlyPremiumAmountWhenUse &&
                                                        coupon.onlyPremiumAmountWhenUse.toLocaleString()}
                                                      {`円`}
                                                    </TableCell>
                                                  </TableRow>
                                                </>
                                              )}
                                            </TableBody>
                                          </Table>
                                        </div>
                                      );
                                    })
                                  )}
                                </>
                              )}
                              {gochi.sourceTable === 'GOCHI_KID' && (
                                <div className={classes.gochiBox} key={key}>
                                  <div
                                    className={classNames(
                                      classes.remainCoupon,
                                      classes.gochiHeader
                                    )}
                                  >
                                    <span>
                                      <b>こどもこちめし利用状況</b>
                                    </span>
                                  </div>

                                  <Table>
                                    <TableBody className={classes.tableInfo}>
                                      <TableRow
                                        className={classes.tableInfoRow}
                                      >
                                        <TableCell
                                          className={
                                            classes.tableInfoCellHeader
                                          }
                                        >
                                          利用日
                                        </TableCell>
                                        <TableCell
                                          className={classes.tableInfoCell}
                                        >
                                          {gochi.useDate}
                                        </TableCell>
                                      </TableRow>
                                      <TableRow>
                                        <TableCell
                                          className={
                                            classes.tableInfoCellHeader
                                          }
                                        >
                                          利用者名
                                        </TableCell>
                                        <TableCell
                                          className={classes.tableInfoCell}
                                        >
                                          {gochi.registerName}
                                        </TableCell>
                                      </TableRow>
                                      <TableRow>
                                        <TableCell
                                          className={
                                            classes.tableInfoCellHeader
                                          }
                                        >
                                          資金グループ名
                                        </TableCell>
                                        <TableCell
                                          className={classes.tableInfoCell}
                                        >
                                          {gochi.gochiKidGroupName}
                                        </TableCell>
                                      </TableRow>
                                      <TableRow>
                                        <TableCell
                                          className={
                                            classes.tableInfoCellHeader
                                          }
                                        >
                                          利用こども氏名
                                        </TableCell>
                                        <TableCell
                                          className={classes.tableInfoCell}
                                        >
                                          {gochi.userKids &&
                                            gochi.userKids.length > 0 &&
                                            gochi.userKids.map(
                                              (userKid, index) => {
                                                return (
                                                  <>
                                                    {userKid.displayName}
                                                    {index ===
                                                    gochi.userKids.length -
                                                      1 ? (
                                                      ''
                                                    ) : (
                                                      <br />
                                                    )}
                                                  </>
                                                );
                                              }
                                            )}
                                        </TableCell>
                                      </TableRow>
                                      <TableRow>
                                        <TableCell
                                          className={
                                            classes.tableInfoCellHeader
                                          }
                                        >
                                          メニュー名
                                        </TableCell>
                                        <TableCell
                                          className={classes.tableInfoCell}
                                        >
                                          {gochi.menuName}
                                        </TableCell>
                                      </TableRow>
                                      <TableRow>
                                        <TableCell
                                          className={
                                            classes.tableInfoCellHeader
                                          }
                                        >
                                          使用時の店舗振込額
                                        </TableCell>
                                        <TableCell
                                          className={classes.tableInfoCell}
                                        >
                                          {gochi.amountTransferToShopWhenUseTotal &&
                                            gochi.amountTransferToShopWhenUseTotal.toLocaleString()}
                                          {`円`}
                                        </TableCell>
                                      </TableRow>
                                      <TableRow>
                                        <TableCell
                                          className={
                                            classes.tableInfoCellHeader
                                          }
                                        >
                                          入金予定
                                        </TableCell>
                                        <TableCell
                                          className={classes.tableInfoCell}
                                        >
                                          利用日の翌月振込
                                        </TableCell>
                                      </TableRow>
                                      <TableRow>
                                        <TableCell
                                          className={
                                            classes.tableInfoCellHeader
                                          }
                                        >
                                          感謝メッセージ
                                        </TableCell>
                                        <TableCell
                                          className={classes.tableInfoCell}
                                        >
                                          {gochi.gochiMessage}
                                        </TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </div>
                              )}
                            </>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </Paper>

              {hasMore && (
                <div className={classes.textCenter}>
                  <Button
                    variant="contained"
                    color="primary"
                    siz="xs"
                    // className={classes.buttonSend}
                    onClick={() => {
                      loadMoreGochis();
                    }}
                  >
                    もっと見る
                  </Button>
                </div>
              )}
            </div>

            <div>
              <Modal open={openNotifyPopup}>
                <NotifyPopupShop
                  setOpenNotifyPopup={setOpenNotifyPopup}
                  textTitle={textTitle}
                  textMessage={textMessage}
                />
              </Modal>
            </div>

            <ProgressDialog
              openProgress={openProgress}
              progressOkAction={progressOkAction}
              loading={loading}
              resultMessage={resultMessage}
            />
            <MenuBox account={account} />
          </div>
        )}
        {viewClassicMode && (
          <div className={classes.rootClassic}>
            <Header
              onMenuClick={() => {
                updateOpenDrawer(true);
              }}
            />

            <div className={classes.mainContent}>
              <div className={classes.pageTitileDiv}>
                <Typography color="textPrimary" className={classes.fs24}>
                  {isFukuoka ? 'クーポン情報管理' : 'ごち情報管理'}
                </Typography>
              </div>
              <Paper className={classes.mainPaper} elevation={1}>
                <div className={classes.searchForm}>
                  <div>
                    <TextField
                      label={isFukuoka ? 'コース名' : 'メニュー名'}
                      placeholder="部分一致"
                      type="search"
                      className={classes.textField300}
                      margin="normal"
                      value={menuName}
                      onChange={e => {
                        setMenuName(e.target.value);
                      }}
                    />
                    <TextField
                      label={isFukuoka ? 'コースID' : 'メニューID'}
                      placeholder="部分一致"
                      type="search"
                      className={classes.textField300}
                      margin="normal"
                      value={menuId}
                      onChange={e => {
                        setMenuId(e.target.value);
                      }}
                    />
                    {!isFukuoka && (
                      <>
                        {' '}
                        <TextField
                          select
                          label="チケット種別"
                          className={classes.textField300}
                          margin="normal"
                          value={gochiType}
                          onChange={e => {
                            handleChangeGochiType(e.target.value);
                          }}
                          InputLabelProps={{
                            shrink: true
                          }}
                        >
                          {gochiTypes.map(type => {
                            return (
                              <MenuItem key={type.id} value={type.id}>
                                {type.name}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                        <TextField
                          select
                          label="使用者種別"
                          className={classes.textField300}
                          margin="normal"
                          disabled={isShashoku || isGochiKid}
                          value={gochiUserType}
                          onChange={e => {
                            setGochiUserType(e.target.value);
                          }}
                          InputLabelProps={{
                            shrink: true
                          }}
                        >
                          {gochiUserTypes.map(type => {
                            return (
                              <MenuItem key={type.id} value={type.id}>
                                {type.name}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                      </>
                    )}
                  </div>
                  <div>
                    {!isFukuoka && (
                      <TextField
                        label="購入者名"
                        placeholder="部分一致"
                        type="search"
                        className={classes.textField300}
                        margin="normal"
                        value={userName}
                        onChange={e => {
                          setUserName(e.target.value);
                        }}
                      />
                    )}
                    <TextField
                      label={gts('領収書NO', educateSystem)}
                      placeholder="部分一致"
                      type="search"
                      disabled={isShashoku || isGochiKid}
                      className={classes.textField300}
                      margin="normal"
                      value={gochiBillNo}
                      onChange={e => {
                        setGochiBillNo(e.target.value);
                      }}
                    />
                  </div>
                  <div>
                    <TextField
                      label={gts('購入日(From)', educateSystem)}
                      type="date"
                      className={classes.textField150}
                      margin="normal"
                      InputLabelProps={{
                        shrink: true
                      }}
                      disabled={isShashoku || isGochiKid}
                      value={gochiDateFrom}
                      onChange={e => {
                        setGochiDateFrom(e.target.value);
                      }}
                    />
                    <TextField
                      label={gts('購入日(To)', educateSystem)}
                      type="date"
                      className={classes.textField150}
                      margin="normal"
                      InputLabelProps={{
                        shrink: true
                      }}
                      disabled={isShashoku || isGochiKid}
                      value={gochiDateTo}
                      onChange={e => {
                        setGochiDateTo(e.target.value);
                      }}
                    />
                  </div>
                  <div>
                    {!isFukuoka && (
                      <TextField
                        select
                        label="使用状況"
                        className={classes.textField300}
                        margin="normal"
                        value={gochiStatus}
                        onChange={e => {
                          setGochiStatus(e.target.value);
                          if (
                            e.target.value === '' ||
                            e.target.value === 'USED'
                          ) {
                            setGochiUseDateEnableFlg(true);
                          } else {
                            setGochiUseDateFrom('');
                            setGochiUseDateTo('');
                            setGochiUseDateEnableFlg(false);
                          }
                        }}
                        InputLabelProps={{
                          shrink: true
                        }}
                      >
                        {gochiStatuses.map(status => {
                          return (
                            <MenuItem key={status.id} value={status.id}>
                              {status.name}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    )}
                    <TextField
                      label="使用日(From)"
                      type="date"
                      className={classes.textField150}
                      margin="normal"
                      InputLabelProps={{
                        shrink: true
                      }}
                      disabled={!gochiUseDateEnableFlg}
                      value={gochiUseDateFrom}
                      onChange={e => {
                        setGochiUseDateFrom(e.target.value);
                      }}
                    />
                    <TextField
                      label="使用日(To)"
                      type="date"
                      className={classes.textField150}
                      margin="normal"
                      InputLabelProps={{
                        shrink: true
                      }}
                      disabled={!gochiUseDateEnableFlg}
                      value={gochiUseDateTo}
                      onChange={e => {
                        setGochiUseDateTo(e.target.value);
                      }}
                    />
                    {!isFukuoka && (
                      <TextField
                        select
                        label="入金予定"
                        className={classes.textField300}
                        margin="normal"
                        value={depositPlan}
                        onChange={e => {
                          setDepositPlan(e.target.value);
                        }}
                        InputLabelProps={{
                          shrink: true
                        }}
                      >
                        {depositPlans.map(plan => {
                          return (
                            <MenuItem key={plan.id} value={plan.id}>
                              {plan.name}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    )}
                  </div>
                  <div className={classes.buttonLeft}>
                    <SearchButton onClickAction={searchActionClassic} />
                  </div>
                  <div className={classes.buttonRight}>
                    <ViewResponsiveModeButton
                      onClickAction={changeToResponsiveViewMode}
                    />
                    {isFukuoka && (
                      <Button
                        variant="outlined"
                        color="primary"
                        style={{ margin: '5px 5px' }}
                        onClick={() => {
                          history.push('/update_amount_history_shop');
                        }}
                      >
                        金額修正履歴
                      </Button>
                    )}
                    {account.fukuokaFlag || isNaha ? (
                      <>
                        <CsvDownloadButton
                          title="検索結果出力（CSV形式）"
                          onClickAction={() => {
                            setIsZip(false);
                            setOpenPopupCsv(true);
                          }}
                        />
                        <CsvDownloadButton
                          title="検索結果出力（ZIP形式）"
                          onClickAction={() => {
                            setIsZip(true);
                            setOpenPopupCsv(true);
                          }}
                        />
                      </>
                    ) : (
                      <>
                        <CsvDownloadButton
                          title="検索結果出力（CSV形式）"
                          onClickAction={() => {
                            csvDownloadAction(false);
                          }}
                        />
                        <CsvDownloadButton
                          title="検索結果出力（ZIP形式）"
                          onClickAction={() => {
                            csvDownloadAction(true);
                          }}
                        />
                      </>
                    )}
                    <div className={classes.textNoteClassicCsv}>
                      ※CSV形式でダウンロードができない場合はZIP形式をお試しください。
                      ZIP形式の説明は
                      <a
                        className={classes.textLinkCsv}
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://shop-guide.gochimeshi.com/individual/p16028/"
                      >
                        こちら
                      </a>
                    </div>
                  </div>
                </div>
                {openTable && (
                  <GochiHistoryTable
                    isShop
                    roles={roles}
                    page={page}
                    handleChangePage={handleChangePage}
                    selectedPage={page}
                    isFukuoka={isFukuoka}
                    isNaha={isNaha}
                    educateSystem={educateSystem}
                    openUpdateAmountModal={openUpdateAmountModal}
                    openUpdateAmountHistory={openUpdateAmountHistory}
                  />
                )}
              </Paper>
              <ProgressDialog
                openProgress={openProgress}
                progressOkAction={progressOkAction}
                loading={loading}
                resultMessage={resultMessage}
              />
            </div>
          </div>
        )}
        <DownloadCsvDialogConfirm
          message="ダウンロード情報には個人情報が含まれますので、取扱いには十分留意してください"
          openChangeConfirm={openPopupCsv}
          updateOpenChangeConfirm={setOpenPopupCsv}
          cancelAction={cancelCsvAction}
          changeAction={downloadCsvAction}
        />

        <div>
          <Modal
            open={showUpdateAmountHistoryModal}
            className={classes.modalMobile}
            onClose={() => {
              setShowUpdateAmountHistoryModal(false);
            }}
          >
            <UpdateAmountHistoryModal
              setShowUpdateAmountHistoryModal={setShowUpdateAmountHistoryModal}
              updateAmountHistoryDetail={updateAmountHistoryDetail}
            />
          </Modal>
        </div>

        <div>
          <Modal
            open={showUpdateAmountModal}
            className={classes.modalMobile}
            onClose={() => {
              setShowUpdateAmountModal(false);
            }}
          >
            <UpdateAmountModal
              amountUpdated={amountUpdated}
              setAmountUpdated={setAmountUpdated}
              validAmountUpdated={validAmountUpdated}
              amountUpdatedError={amountUpdatedError}
              confirmUpdateAmount={confirmUpdateAmount}
              gochiChoseUpdateAmount={gochiChoseUpdateAmount}
            />
          </Modal>
        </div>

        <div>
          <Modal
            open={showUpdateAmountConfirmModal}
            className={classes.modalMobile}
            onClose={() => {
              backConfirmUpdateAmount();
            }}
          >
            <UpdateAmountConfirmModal
              amountUpdated={amountUpdated}
              editAmountEducationSystem={editAmountEducationSystem}
              backConfirmUpdateAmount={backConfirmUpdateAmount}
              gochiChoseUpdateAmount={gochiChoseUpdateAmount}
              systemNameGochiChoseUpdateAmount={
                systemNameGochiChoseUpdateAmount
              }
              oldAmountUpdateAmount={oldAmountUpdateAmount}
            />
          </Modal>
        </div>

        <div>
          <Modal
            open={showUpdateAmountSuccessModal}
            className={classes.modalMobile}
            onClose={() => {
              handleCloseUpdateAmountSuccessModal();
            }}
          >
            <UpdateAmountSuccessModal
              amountUpdated={amountUpdated}
              gochiChoseUpdateAmount={gochiChoseUpdateAmount}
              handleCloseUpdateAmountSuccessModal={
                handleCloseUpdateAmountSuccessModal
              }
              oldAmountUpdateAmount={oldAmountUpdateAmount}
            />
          </Modal>
        </div>
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
